import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  { key: "site_title", label: "Site Başlığı" },
  { key: "logo_url", label: "Logo Görsel URL" },
  { key: "hero_image_url", label: "Hero Görsel URL" },
  { key: "google_play_url", label: "Google Play Linki" },
  { key: "app_store_url", label: "App Store Linki" },
  { key: "contact_email", label: "İletişim E-posta" },
  { key: "contact_phone", label: "İletişim Telefon" },
  { key: "contact_address", label: "İletişim Adres" },
];

export default function SettingsTab({ onSaved }) {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", data);
      toast.success("Site ayarları kaydedildi.");
      onSaved?.();
    } catch {
      toast.error("Kaydedilemedi.");
    } finally {
      setSaving(false);
    }
  };

  if (!data) return <p className="text-[#5C6F62]">Yükleniyor...</p>;

  return (
    <div className="space-y-6 max-w-3xl">
      <div className="grid gap-5 sm:grid-cols-2">
        {FIELDS.map((f) => (
          <label key={f.key} className={`block ${f.key.includes("url") || f.key === "contact_address" ? "sm:col-span-2" : ""}`}>
            <span className="block text-sm font-medium text-[#1A251E] mb-2">{f.label}</span>
            <input
              value={data[f.key] || ""}
              onChange={(e) => setData({ ...data, [f.key]: e.target.value })}
              data-testid={`settings-${f.key}`}
              className="sr-input"
            />
          </label>
        ))}
      </div>
      <div className="flex items-center gap-4">
        <button onClick={save} disabled={saving} data-testid="settings-save-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#0F2F1D] text-white font-semibold hover:bg-[#1B4D2E] transition-colors disabled:opacity-60">
          <Save className="h-4 w-4" /> {saving ? "Kaydediliyor..." : "Kaydet"}
        </button>
        {data.logo_url && <img src={data.logo_url} alt="logo" className="h-12 w-12 rounded-lg object-cover border border-[#E2E8E4]" />}
      </div>
    </div>
  );
}
